/**
 * @param {String} url image url;
 * @param {32|64|128|256} size original image size
 * @return {String} sized image url
 */
export function getSizedAvatarUrl(url, size = 128) {
  if (typeof url === 'string' && !!url) {
    const parsedUrl = url.split('.');
    const ext = parsedUrl.pop();

    return `${parsedUrl.join('.')}x${size}.${ext}`;
  }
  return '';
}
